import React, { useEffect, useState, useMemo } from 'react';
import {
  Box,
  Typography,
  CircularProgress,
  Paper,
  TextField,
  MenuItem,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Switch,
  FormControlLabel,
} from '@mui/material';
import { FixedSizeList as List } from 'react-window';
import Navbar from '../navcomun';
import servicio1 from '../../../services/servicio1';
import Rating from '../rating';
import { Autocomplete } from '@mui/material';
export default function JugadoresMobileConFiltros() {
  const [jugadores, setJugadores] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [filtroNombre, setFiltroNombre] = useState('');
  const [filtroPosicion, setFiltroPosicion] = useState('');
  const [modalAbierto, setModalAbierto] = useState(false);
  const [jugadorSeleccionado, setJugadorSeleccionado] = useState(null);
  const [formData, setFormData] = useState({
    fecha: '',
    hora: '',
    cancha: '',
    mensaje: '',
    pagar: false,
    gratis: false,
  });
const [usarCanchaExistente, setUsarCanchaExistente] = useState(true);
const [canchasExistentes, setCanchasExistentes] = useState([]);
const [canchaSeleccionada, setCanchaSeleccionada] = useState(null);
const [nuevaCancha, setNuevaCancha] = useState({ nombre: '', barrio: '', ciudad: '' });



useEffect(() => {
  
  const fetchJugadoresYCanchas = async () => {
    try {
 
    
        const [jugadoresData, canchasData] = await Promise.all([
          servicio1.traerJugadores(),
          servicio1.traercanchas()
        ]);
        setJugadores(jugadoresData);
        setCanchasExistentes(canchasData);
     
    } catch (error) {
      console.error('Error al traer jugadores o canchas', error);
    } finally {
      setCargando(false);
    }
  };

  fetchJugadoresYCanchas();
}, []);
const estaLogueado = useMemo(() => {
  return !!localStorage.getItem('loggedNoteAppUser');
}, []);
  const posicionesUnicas = useMemo(() => {
    const todas = jugadores.map(j => j.posicion).filter(Boolean);
    return [...new Set(todas)];
  }, [jugadores]);

  const jugadoresFiltrados = useMemo(() => {
    return jugadores.filter(j =>
      (j.nombre?.toLowerCase().includes(filtroNombre.toLowerCase()) ||
        j.apodo?.toLowerCase().includes(filtroNombre.toLowerCase())) &&
      (filtroPosicion ? j.posicion === filtroPosicion : true)
    );
  }, [jugadores, filtroNombre, filtroPosicion]);

  const abrirModal = (jugador) => {
    setJugadorSeleccionado(jugador);
    setModalAbierto(true);
    setFormData({
      fecha: '',
      hora: '',
      cancha: '',
      mensaje: '',
      pagar: false,
      gratis: false,
    });
  };

  const cerrarModal = () => {
    setModalAbierto(false);
    setJugadorSeleccionado(null);
  };

  const handleFormChange = (field, value) => {
    let nuevoForm = { ...formData, [field]: value };
    if (field === 'pagar' && value === true) {
      nuevoForm.gratis = true;
    }
    setFormData(nuevoForm);
  };

const enviarConvocatoria = async () => {
  try {
    const user = JSON.parse(localStorage.getItem('loggedNoteAppUser'));

    const payload = {
      jugador_id: jugadorSeleccionado.id,
      convocador_id: user.id,
      fecha: formData.fecha,
      hora: formData.hora,
      mensaje: formData.mensaje,
      pagar: formData.pagar,
      gratis: formData.gratis,
    };

    if (usarCanchaExistente && canchaSeleccionada) {
      payload.cancha = canchaSeleccionada.nombre;
    } else {
      payload.cancha = nuevaCancha.nombre;
      payload.nueva_cancha_info = {
        nombre: nuevaCancha.nombre,
        barrio: nuevaCancha.barrio,
        ciudad: nuevaCancha.ciudad,
      };
    }

    await servicio1.convocarajugadordirecto(payload);
    alert('Convocatoria enviada');
    cerrarModal();
  } catch (error) {
    console.error('Error al enviar convocatoria', error);
    alert('Error al enviar convocatoria');
  }
};


  const renderRow = ({ index, style }) => {
    const jugador = jugadoresFiltrados[index];
    return (<>
      <Paper
        key={jugador.id}
        style={style}
        elevation={3}
        sx={{
          p: 2,
          mx: 1,
          mb: 1,
          borderRadius: 2,
     
          backgroundColor: '#f9fbe7',
          border: '2px solid #33691e',
          boxShadow: '0 0 10px rgba(0,0,0,0.2)',
        }}
      >
        <Typography variant="subtitle1" fontWeight="bold" color="#1b5e20">
          {jugador.nombre} ({jugador.apodo}) ({jugador.id})
        </Typography>
        <Typography variant="body2">📍 Posición: {jugador.posicion}</Typography>

        <Rating />

        {jugador.dias_disponibles && (() => {
          let dias = [];
          try {
            dias = Array.isArray(jugador.dias_disponibles)
              ? jugador.dias_disponibles
              : JSON.parse(jugador.dias_disponibles);
          } catch (e) {
            dias = [];
          }
          return dias.length > 0 ? (
            <Typography variant="body2" sx={{ color: '#33691e' }}>
              🗓️ Tiene disponibles los días: {dias.join(', ')}
            </Typography>
          ) : null;
        })()}

        {jugador.horarios_disponibles && (
          <Typography variant="body2" sx={{ color: '#558b2f' }}>
            🕒 Horario de preferencia: {jugador.horarios_disponibles}
          </Typography>
        )}

        {jugador.es_pago === 'Si' && (
          <Typography variant="body2" sx={{ color: '#2e7d32', fontWeight: 'bold' }}>
            💰 Jugador pago
          </Typography>
        )}
        {jugador.no_pago_cancha === 'Si' && (
          <Typography variant="body2" sx={{ color: '#ef6c00', fontWeight: 'bold' }}>
            ⚠️ No pagar cancha
          </Typography>
        )}
        {jugador.me_sumo_disponible === 'Si' && (
          <Typography variant="body2" sx={{ color: '#1565c0', fontWeight: 'bold' }}>
            ✅ Siempre disponible
          </Typography>
        )}

      <Button
  variant="contained"
  color="primary"
  fullWidth
  sx={{ mt: 1 }}
  onClick={() => abrirModal(jugador)}
  disabled={!estaLogueado}
>
  Convocar
</Button>
      </Paper></>
    );
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: '#326B6B',
        backgroundImage: 'url(https://www.transparenttextures.com/patterns/grass.png)',
        backgroundRepeat: 'repeat',
        color: 'white',
      }}
    >
      <Navbar />
      <Box sx={{ p: 2 }}>
        <Typography
          variant="h5"
          fontWeight="bold"
          mb={2}
          sx={{
            textAlign: 'center',
            backgroundColor: '#1b5e20',
            color: 'white',
            py: 1,
            borderRadius: 1,
            boxShadow: '0 0 10px rgba(0,0,0,0.5)',
          }}
        >
          ⚽ Lista de Jugadores
        </Typography>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            mb: 2,
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            p: 2,
            borderRadius: 2,
          }}
        >
          <TextField
            label="Buscar por nombre o apodo"
            variant="outlined"
            size="small"
            value={filtroNombre}
            onChange={(e) => setFiltroNombre(e.target.value)}
            fullWidth
            sx={{ backgroundColor: 'white', borderRadius: 1 }}
          />
          <TextField
            select
            label="Filtrar por posición"
            variant="outlined"
            size="small"
            value={filtroPosicion}
            onChange={(e) => setFiltroPosicion(e.target.value)}
            fullWidth
            sx={{ backgroundColor: 'white', borderRadius: 1 }}
          >
            <MenuItem value="">Todas</MenuItem>
            {posicionesUnicas.map((pos) => (
              <MenuItem key={pos} value={pos}>
                {pos}
              </MenuItem>
            ))}
          </TextField>
        </Box>

        {cargando ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
            <CircularProgress sx={{ color: 'white' }} />
          </Box>
        ) : jugadoresFiltrados.length === 0 ? (
          <Typography>No hay jugadores que coincidan con los filtros.</Typography>
        ) : (
      <Box display="flex" flexDirection="column" gap={3}>
  {jugadoresFiltrados.map((jugador, index) => (
    <Box key={jugador.id}>
      {renderRow({ index, style: {} })}
    </Box>
  ))}
</Box>
        )}
      </Box>

      {/* Modal para convocar */}
      <Dialog open={modalAbierto} onClose={cerrarModal} fullWidth>
        <DialogTitle>Convocar a {jugadorSeleccionado?.nombre}</DialogTitle>
        <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
          <TextField
            label="Fecha"
            type="date"
            InputLabelProps={{ shrink: true }}
            value={formData.fecha}
            onChange={(e) => handleFormChange('fecha', e.target.value)}
            fullWidth
          />
          <TextField
            label="Hora"
            type="time"
            InputLabelProps={{ shrink: true }}
            value={formData.hora}
            onChange={(e) => handleFormChange('hora', e.target.value)}
            fullWidth
          />
    <FormControlLabel
  control={
    <Switch
      checked={usarCanchaExistente}
      onChange={() => setUsarCanchaExistente(!usarCanchaExistente)}
    />
  }
  label="¿Usar cancha existente?"
/>

{usarCanchaExistente ? (
  <Autocomplete
    options={canchasExistentes}
    getOptionLabel={(option) =>
      typeof option === 'string' ? option : option.nombre
    }
    value={canchaSeleccionada}
    onChange={(event, newValue) => setCanchaSeleccionada(newValue)}
    renderInput={(params) => (
      <TextField
        {...params}
        label="Seleccionar cancha"
        fullWidth
      />
    )}
    sx={{ mt: 2 }}
  />
) : (
  <Box mt={2}>
    <TextField
      fullWidth
      label="Nombre de la cancha"
      value={nuevaCancha.nombre}
      onChange={(e) => setNuevaCancha({ ...nuevaCancha, nombre: e.target.value })}
      sx={{ mb: 2 }}
    />
    <TextField
      fullWidth
      label="Barrio"
      value={nuevaCancha.barrio}
      onChange={(e) => setNuevaCancha({ ...nuevaCancha, barrio: e.target.value })}
      sx={{ mb: 2 }}
    />
    <TextField
      fullWidth
      label="Ciudad"
      value={nuevaCancha.ciudad}
      onChange={(e) => setNuevaCancha({ ...nuevaCancha, ciudad: e.target.value })}
    />
  </Box>
)}
          <TextField
            label="Mensaje (máx. 60 caracteres)"
            value={formData.mensaje}
            onChange={(e) => handleFormChange('mensaje', e.target.value.slice(0, 60))}
            fullWidth
          />
          <FormControlLabel
            control={
              <Switch
                checked={formData.pagar}
                onChange={(e) => handleFormChange('pagar', e.target.checked)}
              />
            }
            label="¿Pagar al jugador?"
          />
          <FormControlLabel
            control={
              <Switch
                checked={formData.gratis}
                onChange={(e) => handleFormChange('gratis', e.target.checked)}
                disabled={formData.pagar}
              />
            }
            label="¿Jugar gratis?"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={cerrarModal}>Cancelar</Button>
          <Button variant="contained" onClick={enviarConvocatoria}>
            Enviar
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
